/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BabylonContractCodeByteCodeRequest } from '../models/BabylonContractCodeByteCodeRequest';
import type { BabylonContractCodeDetailInfo } from '../models/BabylonContractCodeDetailInfo';
import type { BabylonContractCodeDetailRequest } from '../models/BabylonContractCodeDetailRequest';
import type { BabylonContractCodeListInfo } from '../models/BabylonContractCodeListInfo';
import type { BabylonContractCodeListRequest } from '../models/BabylonContractCodeListRequest';
import type { BabylonContractDetailInfo } from '../models/BabylonContractDetailInfo';
import type { BabylonContractDetailRequest } from '../models/BabylonContractDetailRequest';
import type { BabylonContractExecutedTrxListInfo } from '../models/BabylonContractExecutedTrxListInfo';
import type { BabylonContractExecutedTrxListRequest } from '../models/BabylonContractExecutedTrxListRequest';
import type { BabylonContractHistoryListInfo } from '../models/BabylonContractHistoryListInfo';
import type { BabylonContractHistoryListRequest } from '../models/BabylonContractHistoryListRequest';
import type { BabylonContractListInfo } from '../models/BabylonContractListInfo';
import type { BabylonContractListRequest } from '../models/BabylonContractListRequest';
import type { CommonEmptyRequest } from '../models/CommonEmptyRequest';
import type { EvmContractAbiRequest } from '../models/EvmContractAbiRequest';
import type { EvmContractStatusInfo } from '../models/EvmContractStatusInfo';
import type { EvmContractStatusRequest } from '../models/EvmContractStatusRequest';
import type { EvmContractVerifyInfo } from '../models/EvmContractVerifyInfo';
import type { EvmContractVerifyJsonRequest } from '../models/EvmContractVerifyJsonRequest';
import type { EvmContractVerifyMultiFileRequest } from '../models/EvmContractVerifyMultiFileRequest';
import type { EvmContractVerifySingleFileRequest } from '../models/EvmContractVerifySingleFileRequest';
import type { EvmSolcVersionListInfo } from '../models/EvmSolcVersionListInfo';
import type { HumanityContractCodeInfo } from '../models/HumanityContractCodeInfo';
import type { HumanityContractCodeRequest } from '../models/HumanityContractCodeRequest';
import type { HumanityContractDetailInfo } from '../models/HumanityContractDetailInfo';
import type { HumanityContractDetailRequest } from '../models/HumanityContractDetailRequest';
import type { HumanityContractExecutedTrxListRequest } from '../models/HumanityContractExecutedTrxListRequest';
import type { HumanityContractListInfo } from '../models/HumanityContractListInfo';
import type { HumanityContractListRequest } from '../models/HumanityContractListRequest';
import type { HumanityContractSummaryInfo } from '../models/HumanityContractSummaryInfo';
import type { HumanityContractSummaryRequest } from '../models/HumanityContractSummaryRequest';
import type { HumanityInternalTrxListInfo } from '../models/HumanityInternalTrxListInfo';
import type { HumanityTrxListInfo } from '../models/HumanityTrxListInfo';
import type { SomniaContractCodeInfo } from '../models/SomniaContractCodeInfo';
import type { SomniaContractCodeRequest } from '../models/SomniaContractCodeRequest';
import type { SomniaContractDetailInfo } from '../models/SomniaContractDetailInfo';
import type { SomniaContractDetailRequest } from '../models/SomniaContractDetailRequest';
import type { SomniaContractListInfo } from '../models/SomniaContractListInfo';
import type { SomniaContractListRequest } from '../models/SomniaContractListRequest';
import type { SomniaContractSummaryInfo } from '../models/SomniaContractSummaryInfo';
import type { SomniaContractVerifyInfo } from '../models/SomniaContractVerifyInfo';
import type { ZerogContractCodeInfo } from '../models/ZerogContractCodeInfo';
import type { ZerogContractCodeRequest } from '../models/ZerogContractCodeRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ContractControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getContractDetail({
        requestBody,
    }: {
        requestBody: (BabylonContractDetailRequest | HumanityContractDetailRequest | SomniaContractDetailRequest),
    }): CancelablePromise<(BabylonContractDetailInfo | HumanityContractDetailInfo | SomniaContractDetailInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/contract',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public verifyContractSingleFile({
        requestBody,
    }: {
        requestBody: EvmContractVerifySingleFileRequest,
    }): CancelablePromise<EvmContractVerifyInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/contract/verify/single-file',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public verifyContractMultiFile({
        formData,
    }: {
        formData?: EvmContractVerifyMultiFileRequest,
    }): CancelablePromise<EvmContractVerifyInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/contract/verify/multi-file',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public verifyContractJson({
        formData,
    }: {
        formData?: EvmContractVerifyJsonRequest,
    }): CancelablePromise<EvmContractVerifyInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/contract/verify/json',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public verifyContractVerifyCheck({
        requestBody,
    }: {
        requestBody: SomniaContractCodeRequest,
    }): CancelablePromise<SomniaContractVerifyInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/contract/verify/check',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getContractSummary({
        requestBody,
    }: {
        requestBody: (HumanityContractSummaryRequest | CommonEmptyRequest),
    }): CancelablePromise<(HumanityContractSummaryInfo | SomniaContractSummaryInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/contract/summary',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getContractAddressStatus({
        requestBody,
    }: {
        requestBody: EvmContractStatusRequest,
    }): CancelablePromise<EvmContractStatusInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/contract/status',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getSolcVersionList({
        requestBody,
    }: {
        requestBody: CommonEmptyRequest,
    }): CancelablePromise<EvmSolcVersionListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/contract/solc/version/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getContractList({
        requestBody,
    }: {
        requestBody: (BabylonContractListRequest | HumanityContractListRequest | SomniaContractListRequest),
    }): CancelablePromise<(BabylonContractListInfo | HumanityContractListInfo | SomniaContractListInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/contract/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getContractHistoryList({
        requestBody,
    }: {
        requestBody: BabylonContractHistoryListRequest,
    }): CancelablePromise<BabylonContractHistoryListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/contract/history/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getContractExecutedTrxList({
        requestBody,
    }: {
        requestBody: (BabylonContractExecutedTrxListRequest | HumanityContractExecutedTrxListRequest),
    }): CancelablePromise<(BabylonContractExecutedTrxListInfo | HumanityTrxListInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/contract/executed/trx/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getContractExecutedInternalTrxList({
        requestBody,
    }: {
        requestBody: HumanityContractExecutedTrxListRequest,
    }): CancelablePromise<HumanityInternalTrxListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/contract/executed/internal-trx/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getContractCodeDetail({
        requestBody,
    }: {
        requestBody: (BabylonContractCodeDetailRequest | HumanityContractCodeRequest | SomniaContractCodeRequest | ZerogContractCodeRequest),
    }): CancelablePromise<(BabylonContractCodeDetailInfo | HumanityContractCodeInfo | SomniaContractCodeInfo | ZerogContractCodeInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/contract/code',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getContractCodeList({
        requestBody,
    }: {
        requestBody: BabylonContractCodeListRequest,
    }): CancelablePromise<BabylonContractCodeListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/contract/code/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getContractByteCode({
        requestBody,
    }: {
        requestBody: BabylonContractCodeByteCodeRequest,
    }): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/contract/code/bytecode',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getContractAddressReadFunctions({
        requestBody,
    }: {
        requestBody: EvmContractAbiRequest,
    }): CancelablePromise<EvmContractStatusInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/contract/abi/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
